import { render, staticRenderFns } from "./patientPortalChangeUserName.vue?vue&type=template&id=f6cc9a48&"
import script from "./patientPortalChangeUserName.vue?vue&type=script&lang=js&"
export * from "./patientPortalChangeUserName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports